(function($){
    $(document).ready(function() {

        // prev water color codes
        var water = '75cff0';
        var waterShadow = '6ea5f2';
        var waterwaySmall = '8dcbf7';
        var waterwayRiverCanal = '8dcbf7';

        // new water color codes
        var newWater = '366d84';
        var newWaterShadow = '2D5A6D';
        var newWaterwaySmall = '487A8F';
        var newWaterwayRiverCanal = '487A8F';

        var CustomHoverMap = function(elem,style) {
            var self = this;
            this.element = elem;

            this._addHover = function(value) {
                var color = $(value).attr('data-hover-cl');
                var initColor = $(value).css(style);
                $(value).on('mouseenter',function() {
                    $(value).css(style,color);
                });
                $(value).on('mouseleave',function() {
                    $(value).css(style,initColor);
                });
            };

            this.init = function() {
                self.element.each(function(key,value) {
                    self._addHover(value);
                });
            };

            this.init();
        };

        if($('body').is(':has(#kavlimap)')) {
            var mymap = L.map('kavlimap',{
                attributionControl:false,
                zoomControl:true,
                scrollWheelZoom:false
            });

            // access to layer
            var mapboxgl = {
                accessUrl: 'https://api.mapbox.com/styles/v1/bjartefalck/cj13khst200032rmduqnbp0mk/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYmphcnRlZmFsY2siLCJhIjoiY2oxMjR1MG5qMDAyYzJ3b2dyOWYzcGlyZSJ9.8Q5NoKWI961ypBhrN1DZ_Q',
                accessToken: 'pk.eyJ1IjoiYmphcnRlZmFsY2siLCJhIjoiY2oxM2tnYTh1MDAwcDJ3cnV3eHdpY2p6MyJ9.ZeT9auCn8AnUE6gixaZlRw',
                id: 'mapbox.streets'
            };

            L.tileLayer(mapboxgl.accessUrl, {
                id: mapboxgl.id,
                accessToken: mapboxgl.accessToken
            }).addTo(mymap);

            mymap.setView([40, 0], 2);

            // marks
            var LeafIcon = L.Icon.extend({
                options: {
                    shadowUrl: '../wp-content/themes/kavlifondet/dist/images/icons/mark-shadow.png',
                    iconSize:     [35, 46],
                    shadowSize:   [35, 46],
                    iconAnchor:   [19, 46],
                    shadowAnchor: [19, 46],
                    popupAnchor:  [35, 100]
                }
            });

            $.ajax({
                type: "GET",
                url: window.location.href,
                dataType: 'json',
                data: ({action: 'loadMarks'}),
                success: function(data) {
                    setupMarks(data.posts);
                }
            });
        }

        function setupMarks(marks) {
            var popupOptions = {
                maxHeight:355,
                maxWidth:400,
                minWidth:'auto',
                autoPan:true
            };

            var markers = [];

            $.each(marks,function(key,value) {
                var iconView;
                var $popupHtml;
                var thisMark;
                var mark = value;

                iconView = new LeafIcon({iconUrl: mark.mark_icon});

                $popupHtml = '<div id="mark-banner-' + key + '" class="mark-image"><img src="' + mark.mark_image + '" alt="' + mark.post_title + '"></div>';
                $popupHtml += '<div class="mark-info"><h3 style="color: ' + mark.category_color + '">' + mark.post_title + '</h3>';
                $popupHtml += '<ul>';
                $.each(mark.projects,function(key,value) {
                    $popupHtml += '<li><a class="js-hover-cl" href="' + value.link + '" data-hover-cl="' + mark.category_color + '"><span>' + value.name + '</span><i class="fa fa-chevron-circle-right"></i></a></li>';
                });
                $popupHtml += '</ul></div>';

                thisMark = L.marker([mark.mark_lat, mark.mark_long], {icon: iconView});
                markers.push(thisMark);
                thisMark.addTo(mymap).bindPopup($popupHtml,popupOptions);

                mymap.on("popupopen", function(e){
                    $("#mark-banner-"+key+" img").one("load", function(){
                        var popupWrapper = $(this).closest('.leaflet-popup');
                        var popupHeight = popupWrapper.outerHeight();
                        e.popup.update();
                        popupWrapper.css('bottom',130-popupHeight/2 +'px');
                        var hoverOnMap = new CustomHoverMap($('.js-hover-cl'),'color');
                    });
                });
            });

            // mymap.fitBounds(markers.getBounds());
        }
    });
})(jQuery);

